import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import RequestedItemDetails from './RequestedItemDetails';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, error, message, requestedItemDetails, submitted,
  } = state.market;
  return {
    isLoading,
    error,
    message,
    requestedItemDetails,
    submitted,
  };
}

const Styled = withStyles(styles)(RequestedItemDetails);

export default connect(
  mapStateToProps,
)(Styled);
